import React from 'react';

import { LabelStyled, FallbackStyled } from './fallback.styled';

interface FallbackProps {
  label?: string;
  icon?: React.ReactNode | React.ReactNode[];
}

const Fallback = ({ icon, label = 'Nothing here...' }: FallbackProps) => {
  return (
    <FallbackStyled>
      {icon || null}
      {label ? <LabelStyled>{label}</LabelStyled> : null}
    </FallbackStyled>
  );
};

export default Fallback;
